// extracted by mini-css-extract-plugin
export default {"errorWrapper":"NotFound_errorWrapper__9WbVT"};